import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import {
  Route,
  Redirect,
  Switch,
  useLocation,
  useHistory
} from "react-router-dom";

import Layout from "shared/layout";
import {
  Slidekick,
  Bingo,
  Homepage,
  SignIn,
  SessionLobby,
  PasswordReset,
  Challenges,
  Challenge,
  MyEntries,
  ChallengeSummary,
  LT,
  LTS,
  CC,
  TTL,
  WELL,
  TOTO,
  GAH,
  VB,
  TOT,
  TW,
  FLUS,
  DW20,
  InvalidURL,
  CT,OCH,
  CHPT,InviteTeammates
} from "../pages";

const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        rest.roomCreated ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const location = useLocation();
  const history = useHistory();
  const {
    gameReducer: { roomObj, currentUser },
    challengesReducer: { challenge_button }
  } = useSelector((state) => state);

  const roomCreated = !_.isEmpty(roomObj);

  useEffect(() => {
    if (
      !_.isEmpty(currentUser) &&
      ["/signin", "/password_reset"].includes(location.pathname)
    ) {
      history.replace("/");
    }
  }, [history, currentUser, location.pathname]);

  return (
    <Switch>
      <PublicRoute exact path="/" component={Homepage} />
      <PublicRoute path="/signin" component={SignIn} />
      <PublicRoute path="/lobby" component={SessionLobby} />
      <PublicRoute path="/password_reset" component={PasswordReset} />

      <PrivateRoute path="/bingo" component={Bingo} roomCreated={roomCreated} />
      <PrivateRoute
        path="/slidekick"
        component={Slidekick}
        roomCreated={roomCreated}
      />
      <PrivateRoute
        path="/lightning_trivia"
        component={LT}
        roomCreated={roomCreated}
      />
      <PrivateRoute
        path="/lightning_trivia_submit"
        component={LTS}
        roomCreated={roomCreated}
      />
      <PrivateRoute path="/say_what" component={CC} roomCreated={roomCreated} />
      <PrivateRoute
        path="/two_truths_and_a_lie"
        component={TTL}
        roomCreated={roomCreated}
      />
      <PrivateRoute
        path="/wellness"
        component={WELL}
        roomCreated={roomCreated}
      />
      <PrivateRoute
        component={TOTO}
        path="/tip_of_the_tongue_one_round"
        roomCreated={roomCreated}
      />
      <PrivateRoute
        component={GAH}
        path="/gifs_against_humanity"
        roomCreated={roomCreated}
      />
      <PublicRoute path="/fluster" component={FLUS} roomCreated={roomCreated} />
      <PrivateRoute path="/verboden" component={VB} roomCreated={roomCreated} />
      <PrivateRoute
        path="/tip_of_the_tongue"
        component={TOT}
        roomCreated={roomCreated}
      />
      <PrivateRoute path="/the_word" component={TW} roomCreated={roomCreated} />
      <PrivateRoute
        path="/done_with_2020"
        component={DW20}
        roomCreated={roomCreated}
      />
      <PublicRoute
        path="/conspiracy_theory"
        component={CT}
        roomCreated={roomCreated}
      />
      <PublicRoute
        path="/charty_party"
        component={CHPT}
        roomCreated={roomCreated}
      />
       <PublicRoute
        path="/ochos_locos"
        component={OCH}
        roomCreated={roomCreated}
      />
       <PublicRoute
        path="/invite_teammates"
        component={InviteTeammates}
        roomCreated={roomCreated}
      />
      <PrivateRoute
        exact
        path="/challenges"
        component={Challenges}
        roomCreated={challenge_button}
      />
      <PrivateRoute
        exact
        component={Challenge}
        roomCreated={challenge_button}
        path="/challenge/:challenge_id"
      />
      <PrivateRoute
        exact
        component={MyEntries}
        roomCreated={challenge_button}
        path="/challenge/:challenge_id/my_entries"
      />
      <PrivateRoute
        exact
        component={ChallengeSummary}
        roomCreated={challenge_button}
        path="/challenge/:challenge_id/team_leaderboard"
      />
      <PublicRoute path="*" component={InvalidURL} />
    </Switch>
  );
};

export default Routes;
